import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import * as TableUI from '../../../../components/Table/Table'
import {useRoleAccess} from '../../../../hooks/useRoleAccess'

export const RowHead = memo(() => {
  const {t} = useTranslation()
  const {update: canUpdate, delete: canDelete} = useRoleAccess()

  return (
    <TableUI.THead>
      <tr>
        <th>{t('No')}</th>
        <th>{t('End User Name')}</th>
        <th>{t('Address')}</th>
        <th>{t('City')}</th>
        <th>{t('Province')}</th>
        <th>{t('Phone Number')}</th>
        <th>{t('Email')}</th>
        <th>{t('segment')}</th>
        <th>{t('Bidang Usaha')}</th>
        {canUpdate || canDelete ? <th>{t('order-aksi')}</th> : <th>&nbsp;</th>}
      </tr>
    </TableUI.THead>
  )
})
